module.exports = __webpack_public_path__ + "static/media/deskRenderIso.7b39edd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/deskRenderIso.png
// module id = 163
// module chunks = 0